import { render, staticRenderFns } from "./list.vue?vue&type=template&id=4bcc6fd0&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&lang=css&"
import style1 from "./list.vue?vue&type=style&index=1&id=4bcc6fd0&lang=scss&scoped=true&"
import style2 from "./list.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcc6fd0",
  null
  
)

export default component.exports